import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ar: {
    translation: {
      // App name
      appName: "HELCOO CRM",
      appDescription: "نظام إدارة العقارات والعملاء",
      
      // Login page hero section
      premiumRealEstate: "عقارات فاخرة",
      heroTitle1: "إدارة العقارات",
      heroTitle2: "بذكاء اصطناعي",
      heroDescription: "نظام متكامل لإدارة العملاء والعقارات مع ردود تلقائية ذكية على الواتساب وفيسبوك وإنستغرام",
      propertiesCount: "عقار",
      clientsCount: "عميل",
      smartSupport: "دعم ذكي",
      noAccount: "ليس لديك حساب؟",
      registerCompany: "تسجيل شركة جديدة",
      haveInviteCode: "لدي كود دعوة",
      
      // Auth
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      username: "اسم المستخدم",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      enterEmail: "أدخل البريد الإلكتروني",
      enterUsername: "أدخل اسم المستخدم",
      enterPassword: "أدخل كلمة المرور",
      demoAccount: "الحساب الافتراضي",
      loginSuccess: "تم تسجيل الدخول بنجاح",
      loginError: "خطأ في تسجيل الدخول",
      
      // Navigation
      dashboard: "لوحة التحكم",
      leads: "العملاء",
      pipeline: "مسار المبيعات",
      properties: "العقارات",
      appointments: "المواعيد",
      messages: "الرسائل الحية",
      conversations: "سجل المحادثات",
      team: "إدارة الفريق",
      leaderboard: "لوحة المتصدرين",
      reports: "التقارير",
      settings: "الإعدادات",
      more: "المزيد",
      
      // Dashboard
      welcomeMessage: "مرحباً بك في نظام الردود التلقائية",
      activeConversations: "محادثات نشطة",
      totalConversations: "إجمالي المحادثات",
      totalProducts: "عدد المنتجات",
      totalMessages: "إجمالي الرسائل",
      connectionStatus: "حالة الربط",
      waitingSetup: "في انتظار الإعداد",
      connected: "متصل",
      startWithBot: "ابدأ باستخدام البوت الذكي",
      startBotDescription: "قم بإضافة منتجاتك وربط حسابات فيسبوك وإنستغرام لتفعيل الردود التلقائية",
      addProducts: "إضافة منتجات",
      
      // Leads
      manageLeads: "إدارة قاعدة العملاء المحتملين",
      addLead: "إضافة عميل",
      searchLeads: "بحث بالاسم أو رقم الجوال...",
      totalLeads: "إجمالي العملاء",
      hot: "ساخن",
      warm: "دافئ",
      cold: "بارد",
      assigned: "معين",
      name: "الاسم",
      phone: "رقم الجوال",
      email: "البريد الإلكتروني",
      budget: "الميزانية",
      preferences: "التفضيلات",
      source: "المصدر",
      status: "الحالة",
      notes: "ملاحظات",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      
      // Team
      manageTeam: "إدارة موظفي المبيعات وتخصصاتهم",
      addEmployee: "إضافة موظف",
      invitationCodes: "أكواد الدعوة",
      totalEmployees: "إجمالي الموظفين",
      active: "نشط",
      salesAgent: "مندوب مبيعات",
      branchManager: "مدير فرع",
      admin: "مدير",
      experience: "خبرة",
      years: "سنوات",
      currentLeads: "العملاء الحاليين",
      disable: "تعطيل",
      details: "تفاصيل",
      autoTranslateHint: "سيتم الترجمة للعربية تلقائياً",
      stop: "إيقاف",
      enable: "تفعيل",
      stopLeadReception: "إيقاف استلام العملاء",
      enableLeadReception: "تفعيل استلام العملاء",
      receivesLeads: "يستلم عملاء",
      stopped: "موقوف",
      employees: "الموظفين",
      
      // Invitation Codes
      manageInvitationCodes: "إدارة أكواد الدعوة",
      createNewCode: "إنشاء كود دعوة جديد",
      role: "الدور",
      codeValidity: "صلاحية الكود",
      oneDay: "يوم واحد",
      sevenDays: "7 أيام",
      thirtyDays: "30 يوم",
      createCode: "إنشاء كود جديد",
      currentCodes: "الأكواد الحالية",
      used: "مُستخدم",
      expired: "منتهي",
      expires: "ينتهي",
      howToUse: "كيفية الاستخدام",
      step1: "أنشئ كود دعوة جديد",
      step2: "انسخ الكود وأرسله للموظف الجديد",
      step3: "يستخدم الموظف الكود للتسجيل في صفحة التسجيل",
      registrationLink: "رابط صفحة التسجيل",
      
      // Registration
      employeeRegistration: "تسجيل موظف جديد",
      enterInvitationCode: "أدخل كود الدعوة",
      enterCodeDescription: "أدخل الكود المرسل من قبل المدير",
      whoAreYou: "من أنت؟",
      employee: "موظف",
      workAtCompany: "أعمل في شركة عقارية",
      companyOwner: "صاحب شركة",
      ownCompany: "أملك شركة عقارية",
      invitationCode: "كود الدعوة",
      verifyCode: "تحقق من الكود",
      verifying: "جاري التحقق...",
      haveAccount: "لديك حساب بالفعل؟",
      createAccount: "إنشاء حسابك",
      fullName: "الاسم الكامل",
      confirmPassword: "تأكيد كلمة المرور",
      phoneNumber: "رقم الجوال",
      next: "التالي",
      previous: "السابق",
      completeProfile: "أكمل ملفك الشخصي",
      tellUsAboutYou: "أخبرنا عن خبراتك",
      nationality: "الجنسية",
      yearsOfExperience: "سنوات الخبرة",
      languages: "اللغات",
      specializations: "التخصصات",
      areas: "المناطق المتخصص بها",
      bio: "نبذة عنك",
      bioPlaceholder: "أخبرنا عن خبراتك ومهاراتك...",
      createAccountBtn: "إنشاء الحساب",
      creatingAccount: "جاري إنشاء الحساب...",
      
      // Reports
      performanceReports: "تقارير الأداء",
      monthlyTracking: "متابعة أداء فريق المبيعات شهرياً",
      activeAgents: "الموظفين النشطين",
      newLeads: "عملاء جدد",
      dealsWon: "صفقات ناجحة",
      avgConversion: "متوسط التحويل",
      agentPerformance: "أداء الموظفين",
      clickForDetails: "اضغط على موظف لعرض تقرير تفصيلي",
      rank: "الترتيب",
      agent: "الموظف",
      newThisMonth: "جدد هذا الشهر",
      won: "ناجح",
      lost: "خسارة",
      conversion: "التحويل",
      workload: "الحمولة",
      noAgents: "لا يوجد موظفين",
      noData: "لا توجد بيانات",
      noDataForPeriod: "لا توجد بيانات متاحة لهذه الفترة",
      loading: "جاري التحميل...",
      
      // Pipeline
      salesPipeline: "مسار المبيعات",
      trackLeadStages: "تتبع مراحل العملاء المحتملين",
      new: "جديد",
      contacted: "تم التواصل",
      qualified: "مؤهل",
      negotiation: "تفاوض",
      closedWon: "تم البيع",
      closedLost: "خسارة",
      passedBy: "مر على",
      agents: "موظفين",
      currentAgent: "الموظف الحالي",
      assignedAt: "تم التعيين",
      agentHistory: "سجل الموظفين السابقين",
      totalAgentsHandled: "إجمالي الموظفين الذين تعاملوا مع هذا العميل",
      swipeToMove: "اسحب للنقل",
      noLeadsInStage: "لا يوجد عملاء في هذه المرحلة",
      leadDetails: "تفاصيل العميل",
      moveToStage: "نقل إلى مرحلة",
      back: "رجوع",
      forward: "تقدم",
      
      // Appointments
      appointmentsManagement: "إدارة المواعيد",
      addAppointment: "إضافة موعد",
      upcoming: "القادمة",
      past: "السابقة",
      cancelled: "الملغية",
      scheduled: "مجدول",
      completed: "مكتمل",
      propertyViewing: "معاينة عقار",
      meeting: "اجتماع",
      call: "مكالمة",
      contractSigning: "توقيع عقد",
      
      // Messages
      liveMessages: "الرسائل الحية",
      trackMessages: "تابع الرسائل الواردة وردود البوت",
      activeChats: "المحادثات النشطة",
      noActiveChats: "لا توجد محادثات نشطة",
      useTestButton: "استخدم زر 'اختبار' لإرسال رسالة تجريبية",
      selectChat: "اختر محادثة لعرضها",
      testBot: "اختبار البوت",
      testBotDescription: "ارسل رسالة تجريبية لرؤية رد البوت",
      customerName: "اسم العميل",
      message: "الرسالة",
      messagePlaceholder: "مثال: كم سعر المنتج X؟",
      sendTestMessage: "إرسال رسالة تجريبية",
      tip: "نصيحة",
      tipAddProducts: "تأكد من إضافة منتجات ليتمكن البوت من الرد",
      test: "اختبار",
      send: "إرسال",
      newConversation: "محادثة جديدة",
      startNewConversation: "ابدأ محادثة جديدة مع عميل تجريبي",
      firstMessage: "الرسالة الأولى",
      startConversation: "بدء المحادثة",
      tipContinueChat: "اختر محادثة من القائمة للمتابعة مع عميل موجود",
      typeCustomerMessage: "اكتب رسالة العميل...",
      simulateCustomerReply: "محاكاة رد العميل - سيتم الرد تلقائياً بواسطة البوت",
      continueConversation: "متابعة المحادثة",
      replyingTo: "الرد على:",
      sendReply: "إرسال الرد",
      messageSent: "تم إرسال الرسالة",
      newChat: "محادثة جديدة",
      
      // Conversations
      conversationsHistory: "سجل المحادثات",
      viewAllConversations: "عرض جميع المحادثات السابقة",
      allConversations: "جميع المحادثات",
      noConversations: "لا توجد محادثات",
      messagesCount: "رسالة",
      close: "إغلاق",
      closed: "مغلق",
      
      // Rotation Settings
      rotationSettings: "إعدادات تدوير العملاء",
      rotationSettingsDesc: "إعدادات نقل العملاء تلقائياً عند عدم اتخاذ إجراء",
      adminOnlyWarning: "هذه الإعدادات متاحة للمدير فقط ولا يمكن للموظفين الاطلاع عليها",
      enableRotation: "تفعيل التدوير التلقائي للعملاء",
      rotationPeriod: "فترة التدوير",
      warningBefore: "تحذير قبل التدوير بـ",
      noWarning: "بدون تحذير",
      hour: "ساعة",
      hours: "ساعات",
      saveRotationSettings: "حفظ إعدادات التدوير",
      runRotationNow: "تشغيل التدوير الآن",
      rotationHistory: "سجل التدوير",
      rotatedFrom: "نُقل من",
      rotatedTo: "إلى",
      rotatedAt: "في",
      rotationReason: "السبب",
      noAction: "عدم اتخاذ إجراء",
      
      // Properties
      propertiesManagement: "إدارة العقارات",
      manageProducts: "إدارة المنتجات والعقارات",
      addProperty: "إضافة عقار",
      propertyDetails: "تفاصيل العقار",
      viewDetails: "عرض التفاصيل",
      addedOn: "تاريخ الإضافة",
      category: "التصنيف",
      price: "السعر",
      currency: "العملة",
      description: "الوصف",
      image: "الصورة",
      imageUrl: "رابط الصورة",
      noProperties: "لا توجد عقارات",
      noPropertiesAvailable: "لا توجد عقارات متاحة حالياً",
      addFirstProperty: "أضف أول عقار للبدء",
      
      // Common
      search: "بحث",
      filter: "فلتر",
      all: "الكل",
      actions: "إجراءات",
      confirm: "تأكيد",
      success: "نجاح",
      error: "خطأ",
      warning: "تحذير",
      info: "معلومة",
      yes: "نعم",
      no: "لا",
      confirmDelete: "هل أنت متأكد من الحذف؟",
      confirmAutoAssign: "هل تريد تعيين جميع العملاء غير المعينين تلقائياً؟",
      noLeads: "لا يوجد عملاء",
      startAddingLeads: "ابدأ بإضافة عميل جديد",
      smartDistribution: "توزيع ذكي",
      editLead: "تحرير عميل",
      addNewLead: "إضافة عميل جديد",
      budgetFrom: "الميزانية من",
      budgetTo: "الميزانية إلى",
      update: "تحديث",
      add: "إضافة",
      unassigned: "غير معين",
      smartAssignment: "تعيين ذكي",
      autoAssignBest: "تعيين تلقائي للأفضل",
      orChooseManually: "أو اختر يدوياً",
      analyzingRecommendations: "جاري تحليل التوصيات...",
      noAvailableAgents: "لا يوجد موظفين متاحين",
      best: "الأفضل",
      preferencesImportant: "التفضيلات (مهم للتوزيع الذكي)",
      preferencesExample: "مثل: شقة 2 غرفة في دبي مارينا، فيلا في نخلة جميرا",
      tipImproveDistribution: "اذكر نوع العقار والمنطقة لتحسين التوزيع الذكي",
      clients: "العملاء",
      back: "رجوع",
      forward: "تقدم",
      leadDetails: "تفاصيل العميل",
      stage: "المرحلة",
      moveToStage: "نقل إلى مرحلة",
      
      // Follow-ups (المتابعات)
      followUps: "المتابعات",
      followUp: "المتابعة",
      setFollowUp: "تحديد موعد متابعة",
      followUpDate: "تاريخ المتابعة",
      followUpNotes: "ملاحظات المتابعة",
      followUpSet: "تم تحديد موعد المتابعة",
      followUpIn: "المتابعة بعد",
      followUpTomorrow: "المتابعة غداً",
      followUpOverdue: "موعد المتابعة متأخر!",
      selectDays: "اختر المدة",
      days: "يوم",
      overdue: "متأخرة",
      todayFollowUps: "متابعات اليوم",
      notifications: "الإشعارات",
      noNotifications: "لا توجد إشعارات",
      markAllRead: "قراءة الكل",
      followUpCreatedBy: "تم إنشاؤها بواسطة",
      
      // Rotation Lock (قفل التدوير)
      rotationLocked: "قفل التدوير",
      rotationUnlocked: "التدوير مفعل",
      lockRotation: "قفل التدوير",
      unlockRotation: "فتح التدوير",
      rotationLockedMessage: "تم قفل التدوير لهذا العميل",
      rotationUnlockedMessage: "تم فتح التدوير لهذا العميل",
      rotationLockedBy: "تم القفل بواسطة",
      noRotation: "لا يُدور",
      
      // Settings
      settingsTitle: "الإعدادات",
      settingsDescription: "إعدادات البوت وربط الحسابات",
      connectFacebook: "ربط فيسبوك",
      connectInstagram: "ربط إنستغرام",
      connectWhatsapp: "ربط واتساب",
      botSettings: "إعدادات البوت",
      responseStyle: "نمط الرد",
      welcomeMessageSetting: "رسالة الترحيب",
      enableAutoReply: "تفعيل الرد التلقائي",
      saveSettings: "حفظ الإعدادات",
      howToConnect: "كيفية ربط الحسابات",
      
      // Quiet Hours Settings (إعدادات فترة الراحة)
      quietHoursSettings: "إعدادات فترة الراحة",
      quietHoursDescription: "تحديد أوقات إيقاف التدوير التلقائي",
      appQuietHours: "فترة راحة التطبيق",
      appQuietHoursDesc: "إيقاف التدوير في هذه الفترة بتوقيت التطبيق",
      clientQuietHours: "فترة راحة العميل",
      clientQuietHoursDesc: "احترام المنطقة الزمنية للعميل بناءً على كود الدولة",
      respectClientTimezone: "تفعيل احترام توقيت العميل",
      quietStart: "من الساعة",
      quietEnd: "إلى الساعة",
      appTimezone: "المنطقة الزمنية للتطبيق (UTC+)",
      quietHoursSaved: "تم حفظ إعدادات فترة الراحة",
      
      // Reports
      performanceReports: "تقارير الأداء",
      monthlyTracking: "متابعة أداء فريق المبيعات شهرياً",
      loadingReport: "جاري تحميل التقرير...",
      activeAgents: "الموظفين النشطين",
      newLeads: "عملاء جدد",
      dealsWon: "صفقات ناجحة",
      avgConversion: "متوسط التحويل",
      agentPerformance: "أداء الموظفين",
      clickForDetails: "اضغط على موظف لعرض تقرير تفصيلي",
      rank: "الترتيب",
      agent: "الموظف",
      totalClients: "إجمالي العملاء",
      newThisMonth: "جدد هذا الشهر",
      won: "ناجح",
      lost: "خسارة",
      conversion: "التحويل",
      appointmentsCount: "المواعيد",
      workload: "الحمولة",
      noAgents: "لا يوجد موظفين",
      noData: "لا توجد بيانات",
      noDataForPeriod: "لا توجد بيانات متاحة لهذه الفترة",
      agentPerformanceReport: "تقرير أداء الموظف",
      stagesDistribution: "توزيع المراحل",
      monthlyPerformance: "الأداء الشهري (آخر 6 أشهر)",
      recentClients: "آخر العملاء",
      
      // Appointments
      appointmentsTitle: "المواعيد",
      appointmentsDescription: "إدارة مواعيد المعاينات والاجتماعات",
      newAppointment: "موعد جديد",
      totalAppointments: "إجمالي المواعيد",
      upcoming: "قادمة",
      past: "السابقة",
      cancelled: "ملغية",
      completed: "مكتملة",
      pending: "معلقة",
      noAppointments: "لا توجد مواعيد",
      startAddingAppointment: "ابدأ بإضافة موعد جديد",
      editAppointment: "تعديل الموعد",
      addNewAppointment: "إضافة موعد جديد",
      title: "العنوان",
      titleExample: "مثال: معاينة شقة في دبي مارينا",
      client: "العميل",
      selectClient: "اختر عميل",
      date: "التاريخ",
      time: "الوقت",
      type: "النوع",
      location: "الموقع",
      locationExample: "مثال: دبي مارينا، برج X",
      optional: "اختياري",
      propertyViewing: "معاينة عقار",
      meeting: "اجتماع",
      call: "مكالمة",
      contractSigning: "توقيع عقد",
      
      // Messages
      liveMessages: "الرسائل الحية",
      trackMessages: "تابع الرسائل الواردة وردود البوت",
      activeChats: "المحادثات النشطة",
      noActiveChats: "لا توجد محادثات نشطة",
      useTestButton: "استخدم زر 'اختبار' لإرسال رسالة تجريبية",
      selectChat: "اختر محادثة لعرضها",
      testBot: "اختبار البوت",
      testBotDescription: "ارسل رسالة تجريبية لرؤية رد البوت",
      customerName: "اسم العميل",
      message: "الرسالة",
      messagePlaceholder: "مثال: كم سعر المنتج X؟",
      sendTestMessage: "إرسال رسالة تجريبية",
      tip: "نصيحة",
      tipAddProducts: "تأكد من إضافة منتجات ليتمكن البوت من الرد",
      test: "اختبار",
      send: "إرسال",
      
      // Conversations
      conversationsHistory: "سجل المحادثات",
      viewAllConversations: "عرض جميع المحادثات السابقة",
      allConversations: "جميع المحادثات",
      noConversations: "لا توجد محادثات",
      messagesCount: "رسالة",
      close: "إغلاق",
      closed: "مغلق",
      selectConversation: "اختر محادثة لعرضها",
      
      // Properties
      propertiesManagement: "إدارة العقارات",
      manageProducts: "إدارة المنتجات والعقارات",
      addProperty: "إضافة عقار",
      price: "السعر",
      currency: "العملة",
      description: "الوصف",
      image: "الصورة",
      imageUrl: "رابط الصورة",
      noProperties: "لا توجد عقارات",
      addFirstProperty: "أضف أول عقار للبدء",
      editProduct: "تحرير منتج",
      addNewProduct: "إضافة منتج جديد",
      productName: "اسم المنتج",
      available: "متوفر",
      unavailable: "غير متوفر",
      
      // Team page
      teamTitle: "إدارة الفريق",
      teamDescription: "إدارة موظفي المبيعات وتخصصاتهم",
      employeeDetails: "تفاصيل الموظف",
      editEmployee: "تحرير موظف",
      addNewEmployee: "إضافة موظف جديد",
      fullName: "الاسم الكامل",
      emailAddress: "البريد الإلكتروني",
      phoneNumber: "رقم الجوال",
      selectNationality: "اختر الجنسية",
      yearsOfExperience: "سنوات الخبرة",
      specializations: "التخصصات",
      areas: "المناطق المتخصص بها",
      languages: "اللغات",
      maxLeads: "الحد الأقصى للعملاء النشطين",
      bioDescription: "نبذة عن الموظف",
      bioPlaceholder: "وصف مختصر عن خبرات ومهارات الموظف...",
      workloadBar: "حمولة العمل",
      inactive: "معطل",
      enable: "تفعيل",
      
      // Register
      employeeRegistration: "تسجيل موظف جديد",
      enterInvitationCode: "أدخل كود الدعوة",
      enterCodeDescription: "أدخل الكود المرسل من قبل المدير",
      whoAreYou: "من أنت؟",
      employee: "موظف",
      workAtCompany: "أعمل في شركة عقارية",
      companyOwner: "صاحب شركة",
      ownCompany: "أملك شركة عقارية",
      invitationCode: "كود الدعوة",
      invitationCodeExample: "مثال: AQR-ABCD12",
      verifyCode: "تحقق من الكود",
      verifying: "جاري التحقق...",
      haveAccount: "لديك حساب بالفعل؟",
      createAccount: "إنشاء حسابك",
      roleLabel: "الدور",
      confirmPassword: "تأكيد كلمة المرور",
      passwordMinLength: "6 أحرف على الأقل",
      reenterPassword: "أعد كتابة كلمة المرور",
      next: "التالي",
      previous: "السابق",
      completeProfile: "أكمل ملفك الشخصي",
      tellUsAboutYou: "أخبرنا عن خبراتك",
      nationality: "الجنسية",
      bio: "نبذة عنك",
      createAccountBtn: "إنشاء الحساب",
      creatingAccount: "جاري إنشاء الحساب...",
      accountInfo: "معلومات الحساب",
      profile: "الملف الشخصي",
      passwordsNotMatch: "كلمات المرور غير متطابقة",
      passwordTooShort: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      registrationSuccess: "تم التسجيل بنجاح! يمكنك الآن تسجيل الدخول",
      registrationFailed: "فشل التسجيل",
      pleaseEnterCode: "الرجاء إدخال كود الدعوة",
      pleaseSelectType: "الرجاء اختيار نوع الحساب",
      codeVerified: "تم التحقق من كود الدعوة بنجاح!",
      invalidCode: "كود الدعوة غير صالح",
      
      loading: "جاري التحميل...",
      realtimeCRM: "نظام CRM العقاري",
      
      // Nationalities
      emirati: "إماراتي",
      saudi: "سعودي",
      iraqi: "عراقي",
      egyptian: "مصري",
      jordanian: "أردني",
      indian: "هندي",
      pakistani: "باكستاني",
      russian: "روسي",
      british: "بريطاني",
      american: "أمريكي",
      chinese: "صيني",
      
      // Languages
      arabic: "العربية",
      english: "الإنجليزية",
      hindi: "الهندية",
      urdu: "الأردية",
      russianLang: "الروسية",
      chineseLang: "الصينية",
      french: "الفرنسية",
      german: "الألمانية",
      spanish: "الإسبانية",
      persian: "الفارسية",
      turkish: "التركية",
      
      // Specializations
      apartments: "شقق",
      villas: "فلل",
      commercial: "تجاري",
      offices: "مكاتب",
      lands: "أراضي",
      
      // Areas (legacy - now using geoData.js)
      dubaiMarina: "دبي مارينا",
      palmJumeirah: "نخلة جميرا",
      downtown: "داون تاون",
      jbr: "JBR",
      businessBay: "بزنس باي",
      jumeirah: "جميرا",
      alBarsha: "البرشاء",
      emiratesHills: "تلال الإمارات",
      
      // Months
      january: "يناير",
      february: "فبراير",
      march: "مارس",
      april: "أبريل",
      may: "مايو",
      june: "يونيو",
      july: "يوليو",
      august: "أغسطس",
      september: "سبتمبر",
      october: "أكتوبر",
      november: "نوفمبر",
      december: "ديسمبر",
      
      // Time periods
      today: "اليوم",
      thisWeek: "هذا الأسبوع",
      thisMonth: "هذا الشهر",
      thisQuarter: "هذا الربع",
      allPeriods: "كل الفترات",
      week: "الأسبوع",
      month: "الشهر",
      quarter: "الربع",
      year: "السنة",
      
      // Reports
      performanceReports: "تقارير الأداء",
      salesPerformanceAnalysis: "متابعة وتحليل أداء فريق المبيعات",
      monthlyReport: "التقرير الشهري",
      overview: "نظرة عامة",
      teamPerformance: "أداء الفريق",
      trends: "الاتجاهات",
      topSalesAgents: "ترتيب أفضل موظفي المبيعات",
      
      // Pipeline stages
      pipelineNew: "جديد",
      pipelineQualified: "مؤهل",
      pipelineUnqualified: "غير مؤهل",
      pipelineNegotiation: "تفاوض",
      pipelineClosedWon: "تم البيع",
      pipelineClosedLost: "خسارة",
      
      // Unqualified reasons
      reason: "السبب",
      unqualifiedReason: "سبب عدم التأهيل",
      insufficientBudget: "ميزانية غير كافية",
      notSerious: "غير جاد",
      outOfScope: "خارج نطاق الخدمة",
      incorrectInfo: "معلومات غير صحيحة",
      otherReason: "أخرى",
      specifyReason: "حدد السبب...",
      
      // Document upload
      uploadDocument: "رفع مستند",
      documentRequired: "يجب رفع جواز السفر أو الهوية للانتقال إلى هذه المرحلة",
      uploadPassportOrId: "رفع جواز السفر أو الهوية",
      capturePhoto: "التقاط صورة",
      chooseFromGallery: "اختيار من المعرض",
      extractingData: "جاري استخراج البيانات...",
      documentUploaded: "تم رفع المستند",
      ocrSuccess: "تم استخراج البيانات بنجاح",
      ocrFailed: "فشل في قراءة البيانات",
      
      // Official data from OCR
      officialData: "البيانات الرسمية",
      officialName: "الاسم الرسمي",
      documentNumber: "رقم الهوية/الجواز",
      nationality: "الجنسية",
      dateOfBirth: "تاريخ الميلاد",
      documentExpiry: "تاريخ انتهاء الصلاحية",
      expiringDocuments: "مستندات قريبة الانتهاء",
      daysUntilExpiry: "أيام حتى الانتهاء",
      
      // Stage change
      changeStage: "تغيير المرحلة",
      stageHistory: "سجل تغييرات المراحل",
      changedBy: "تم التغيير بواسطة",
      changedAt: "تاريخ التغيير",
      
      // Creator and Distributor (من أضاف ومن وزّع)
      addedBy: "أضافه",
      addedVia: "أُضيف عبر",
      distributedBy: "وزّعه",
      distributionType: "نوع التوزيع",
      manualDistribution: "يدوي",
      smartDistributionType: "توزيع ذكي",
      autoDistribution: "تلقائي",
      manual: "يدوي",
      unknown: "غير معروف",
      
      // Client Number & Duplicate Detection (الرقم التسلسلي وكشف التكرار)
      clientNumber: "رقم العميل",
      duplicateDetected: "عميل مكرر محتمل",
      duplicateWarning: "يوجد عميل بنفس البيانات",
      duplicatePhone: "رقم الهاتف متطابق",
      duplicateEmail: "البريد الإلكتروني متطابق",
      duplicateBoth: "الهاتف والبريد متطابقان",
      keepBoth: "إضافة كعميل جديد",
      mergeLead: "دمج مع العميل الموجود",
      viewExisting: "عرض العميل الموجود",
      cancelAdd: "إلغاء الإضافة",
      existingClient: "العميل الموجود",
      newClient: "العميل الجديد",
      mergeSuccess: "تم دمج العملاء بنجاح",
      selectPrimaryLead: "اختر العميل الأساسي (سيتم الاحتفاظ به)",
      selectSecondaryLead: "اختر العميل المراد دمجه (سيتم حذفه)",
      
      // Search (البحث)
      searchByNamePhoneClientNumber: "بحث بالاسم، الهاتف، أو رقم العميل (CAE-2600001)...",
      searchResults: "نتائج البحث عن",
      noSearchResults: "لا توجد نتائج للبحث",
      
      // Advanced Filters (الفلاتر المتقدمة)
      advancedFilters: "فلترة متقدمة",
      resetFilters: "مسح الفلاتر",
      allSources: "جميع المصادر",
      website: "موقع إلكتروني",
      messagePermissions: "صلاحيات الرسائل",
      viewLiveMessages: "الرسائل الحية",
      viewConversationHistory: "سجل المحادثات",
      allStatuses: "جميع الحالات",
      allAgents: "جميع الموظفين",
      allTime: "كل الوقت",
      dateAdded: "تاريخ الإضافة",
      today: "اليوم",
      thisWeek: "هذا الأسبوع",
      thisMonth: "هذا الشهر",
      last3Months: "آخر 3 أشهر",
      assignedTo: "معين لـ",
      duplicates: "مكررون",
      
      // Role access descriptions
      adminFullAccess: "⚠️ المدير لديه صلاحيات كاملة على النظام",
      branchManagerAccess: "مدير الفرع يمكنه إدارة الموظفين في فرعه",
      salesAgentAccess: "مندوب المبيعات يرى فقط العملاء المعينين له",
    }
  },
  en: {
    translation: {
      // App name
      appName: "HELCOO CRM",
      appDescription: "Real Estate & Customer Management System",
      
      // Login page hero section
      premiumRealEstate: "Premium Real Estate",
      heroTitle1: "Real Estate Management",
      heroTitle2: "with AI Power",
      heroDescription: "Integrated system for customer and property management with smart auto-replies on WhatsApp, Facebook, and Instagram",
      propertiesCount: "Properties",
      clientsCount: "Clients",
      smartSupport: "Smart Support",
      noAccount: "Don't have an account?",
      registerCompany: "Register New Company",
      haveInviteCode: "I have an invite code",
      
      // Auth
      login: "Login",
      logout: "Logout",
      username: "Username",
      email: "Email",
      password: "Password",
      enterEmail: "Enter your email",
      enterUsername: "Enter username",
      enterPassword: "Enter password",
      demoAccount: "Demo Account",
      loginSuccess: "Login successful",
      loginError: "Login error",
      
      // Navigation
      dashboard: "Dashboard",
      leads: "Leads",
      pipeline: "Sales Pipeline",
      properties: "Properties",
      appointments: "Appointments",
      messages: "Live Messages",
      conversations: "Conversations",
      team: "Team Management",
      leaderboard: "Leaderboard",
      reports: "Reports",
      settings: "Settings",
      more: "More",
      
      // Dashboard
      welcomeMessage: "Welcome to the Auto-Reply System",
      activeConversations: "Active Conversations",
      totalConversations: "Total Conversations",
      totalProducts: "Total Products",
      totalMessages: "Total Messages",
      connectionStatus: "Connection Status",
      waitingSetup: "Waiting for Setup",
      connected: "Connected",
      startWithBot: "Start Using the Smart Bot",
      startBotDescription: "Add your products and connect Facebook & Instagram accounts to enable auto-replies",
      addProducts: "Add Products",
      
      // Leads
      manageLeads: "Manage Potential Customers",
      addLead: "Add Lead",
      searchLeads: "Search by name or phone...",
      totalLeads: "Total Leads",
      hot: "Hot",
      warm: "Warm",
      cold: "Cold",
      assigned: "Assigned",
      name: "Name",
      phone: "Phone",
      email: "Email",
      budget: "Budget",
      preferences: "Preferences",
      source: "Source",
      status: "Status",
      notes: "Notes",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      
      // Team
      manageTeam: "Manage Sales Team & Specializations",
      addEmployee: "Add Employee",
      invitationCodes: "Invitation Codes",
      totalEmployees: "Total Employees",
      active: "Active",
      salesAgent: "Sales Agent",
      branchManager: "Branch Manager",
      admin: "Admin",
      experience: "Experience",
      years: "years",
      currentLeads: "Current Leads",
      disable: "Disable",
      details: "Details",
      autoTranslateHint: "Will be auto-translated to Arabic",
      stop: "Stop",
      enable: "Enable",
      stopLeadReception: "Stop Lead Reception",
      enableLeadReception: "Enable Lead Reception",
      receivesLeads: "Receives Leads",
      stopped: "Stopped",
      employees: "Employees",
      
      // Invitation Codes
      manageInvitationCodes: "Manage Invitation Codes",
      createNewCode: "Create New Invitation Code",
      role: "Role",
      codeValidity: "Code Validity",
      oneDay: "1 Day",
      sevenDays: "7 Days",
      thirtyDays: "30 Days",
      createCode: "Create New Code",
      currentCodes: "Current Codes",
      used: "Used",
      expired: "Expired",
      expires: "Expires",
      howToUse: "How to Use",
      step1: "Create a new invitation code",
      step2: "Copy the code and send it to the new employee",
      step3: "Employee uses the code to register on the registration page",
      registrationLink: "Registration Page Link",
      
      // Registration
      employeeRegistration: "Employee Registration",
      enterInvitationCode: "Enter Invitation Code",
      enterCodeDescription: "Enter the code sent by your administrator",
      whoAreYou: "Who are you?",
      employee: "Employee",
      workAtCompany: "I work at a real estate company",
      companyOwner: "Company Owner",
      ownCompany: "I own a real estate company",
      invitationCode: "Invitation Code",
      verifyCode: "Verify Code",
      verifying: "Verifying...",
      haveAccount: "Already have an account?",
      createAccount: "Create Your Account",
      fullName: "Full Name",
      confirmPassword: "Confirm Password",
      phoneNumber: "Phone Number",
      next: "Next",
      previous: "Previous",
      completeProfile: "Complete Your Profile",
      tellUsAboutYou: "Tell us about your expertise",
      nationality: "Nationality",
      yearsOfExperience: "Years of Experience",
      languages: "Languages",
      specializations: "Specializations",
      areas: "Areas of Expertise",
      bio: "Bio",
      bioPlaceholder: "Tell us about your experience and skills...",
      createAccountBtn: "Create Account",
      creatingAccount: "Creating Account...",
      
      // Reports
      performanceReports: "Performance Reports",
      monthlyTracking: "Monthly Sales Team Performance Tracking",
      activeAgents: "Active Agents",
      newLeads: "New Leads",
      dealsWon: "Deals Won",
      avgConversion: "Avg. Conversion",
      agentPerformance: "Agent Performance",
      clickForDetails: "Click on an agent to view detailed report",
      rank: "Rank",
      agent: "Agent",
      newThisMonth: "New This Month",
      won: "Won",
      lost: "Lost",
      conversion: "Conversion",
      workload: "Workload",
      noAgents: "No agents found",
      noData: "No Data",
      noDataForPeriod: "No data available for this period",
      loading: "Loading...",
      
      // Pipeline
      salesPipeline: "Sales Pipeline",
      trackLeadStages: "Track Lead Stages",
      new: "New",
      contacted: "Contacted",
      qualified: "Qualified",
      negotiation: "Negotiation",
      closedWon: "Closed Won",
      closedLost: "Closed Lost",
      passedBy: "Passed by",
      agents: "agents",
      currentAgent: "Current Agent",
      assignedAt: "Assigned at",
      agentHistory: "Previous Agents History",
      totalAgentsHandled: "Total agents who handled this lead",
      swipeToMove: "Swipe to move",
      noLeadsInStage: "No leads in this stage",
      leadDetails: "Lead Details",
      moveToStage: "Move to stage",
      back: "Back",
      forward: "Forward",
      
      // Appointments
      appointmentsManagement: "Appointments Management",
      addAppointment: "Add Appointment",
      upcoming: "Upcoming",
      past: "Past",
      cancelled: "Cancelled",
      scheduled: "Scheduled",
      completed: "Completed",
      propertyViewing: "Property Viewing",
      meeting: "Meeting",
      call: "Call",
      contractSigning: "Contract Signing",
      
      // Messages
      liveMessages: "Live Messages",
      trackMessages: "Track incoming messages and bot replies",
      activeChats: "Active Chats",
      noActiveChats: "No active chats",
      useTestButton: "Use the 'Test' button to send a test message",
      selectChat: "Select a chat to view",
      testBot: "Test Bot",
      testBotDescription: "Send a test message to see the bot's response",
      customerName: "Customer Name",
      message: "Message",
      messagePlaceholder: "Example: What's the price of product X?",
      sendTestMessage: "Send Test Message",
      tip: "Tip",
      tipAddProducts: "Make sure to add products for the bot to respond",
      test: "Test",
      send: "Send",
      newConversation: "New Conversation",
      startNewConversation: "Start a new conversation with a test customer",
      firstMessage: "First Message",
      startConversation: "Start Conversation",
      tipContinueChat: "Select a chat from the list to continue with an existing customer",
      typeCustomerMessage: "Type customer message...",
      simulateCustomerReply: "Simulate customer reply - Bot will respond automatically",
      continueConversation: "Continue Conversation",
      replyingTo: "Replying to:",
      sendReply: "Send Reply",
      messageSent: "Message sent",
      newChat: "New Chat",
      
      // Conversations
      conversationsHistory: "Conversations History",
      viewAllConversations: "View all past conversations",
      allConversations: "All Conversations",
      noConversations: "No conversations",
      messagesCount: "messages",
      close: "Close",
      
      // Rotation Settings
      rotationSettings: "Lead Rotation Settings",
      rotationSettingsDesc: "Auto-rotate leads when no action is taken",
      adminOnlyWarning: "These settings are for admin only and hidden from employees",
      enableRotation: "Enable automatic lead rotation",
      rotationPeriod: "Rotation Period",
      warningBefore: "Warning before rotation",
      noWarning: "No warning",
      hour: "hour",
      hours: "hours",
      saveRotationSettings: "Save Rotation Settings",
      runRotationNow: "Run Rotation Now",
      rotationHistory: "Rotation History",
      rotatedFrom: "Rotated from",
      rotatedTo: "to",
      rotatedAt: "at",
      rotationReason: "Reason",
      noAction: "No action taken",
      closed: "Closed",
      
      // Properties
      propertiesManagement: "Properties Management",
      manageProducts: "Manage Products & Properties",
      addProperty: "Add Property",
      propertyDetails: "Property Details",
      viewDetails: "View Details",
      addedOn: "Added On",
      category: "Category",
      price: "Price",
      currency: "Currency",
      description: "Description",
      image: "Image",
      imageUrl: "Image URL",
      noProperties: "No properties",
      noPropertiesAvailable: "No properties available at the moment",
      addFirstProperty: "Add your first property to start",
      
      // Common
      search: "Search",
      filter: "Filter",
      all: "All",
      actions: "Actions",
      confirm: "Confirm",
      success: "Success",
      error: "Error",
      warning: "Warning",
      info: "Info",
      yes: "Yes",
      no: "No",
      confirmDelete: "Are you sure you want to delete?",
      confirmAutoAssign: "Do you want to auto-assign all unassigned leads?",
      noLeads: "No leads",
      startAddingLeads: "Start by adding a new lead",
      smartDistribution: "Smart Distribution",
      editLead: "Edit Lead",
      addNewLead: "Add New Lead",
      budgetFrom: "Budget From",
      budgetTo: "Budget To",
      update: "Update",
      add: "Add",
      unassigned: "Unassigned",
      smartAssignment: "Smart Assignment",
      autoAssignBest: "Auto-assign to Best",
      orChooseManually: "Or choose manually",
      analyzingRecommendations: "Analyzing recommendations...",
      noAvailableAgents: "No available agents",
      best: "Best",
      preferencesImportant: "Preferences (Important for smart distribution)",
      preferencesExample: "E.g., 2-bedroom apartment in Dubai Marina, Villa in Palm Jumeirah",
      tipImproveDistribution: "Mention property type and area to improve smart distribution",
      clients: "Clients",
      back: "Back",
      forward: "Forward",
      leadDetails: "Lead Details",
      stage: "Stage",
      moveToStage: "Move to Stage",
      
      // Follow-ups
      followUps: "Follow-ups",
      followUp: "Follow-up",
      setFollowUp: "Set Follow-up",
      followUpDate: "Follow-up Date",
      followUpNotes: "Follow-up Notes",
      followUpSet: "Follow-up set successfully",
      followUpIn: "Follow-up in",
      followUpTomorrow: "Follow-up tomorrow",
      followUpOverdue: "Follow-up overdue!",
      selectDays: "Select duration",
      days: "days",
      overdue: "Overdue",
      todayFollowUps: "Today's Follow-ups",
      notifications: "Notifications",
      noNotifications: "No notifications",
      markAllRead: "Mark all read",
      followUpCreatedBy: "Created by",
      
      // Rotation Lock
      rotationLocked: "Rotation Locked",
      rotationUnlocked: "Rotation Enabled",
      lockRotation: "Lock Rotation",
      unlockRotation: "Unlock Rotation",
      rotationLockedMessage: "Rotation locked for this lead",
      rotationUnlockedMessage: "Rotation unlocked for this lead",
      rotationLockedBy: "Locked by",
      noRotation: "No Rotation",
      
      // Settings
      settingsTitle: "Settings",
      settingsDescription: "Bot settings and account connections",
      connectFacebook: "Connect Facebook",
      connectInstagram: "Connect Instagram",
      connectWhatsapp: "Connect WhatsApp",
      botSettings: "Bot Settings",
      responseStyle: "Response Style",
      welcomeMessageSetting: "Welcome Message",
      enableAutoReply: "Enable Auto Reply",
      saveSettings: "Save Settings",
      howToConnect: "How to Connect Accounts",
      
      // Reports
      performanceReports: "Performance Reports",
      monthlyTracking: "Monthly Sales Team Performance Tracking",
      loadingReport: "Loading report...",
      activeAgents: "Active Agents",
      newLeads: "New Leads",
      dealsWon: "Deals Won",
      avgConversion: "Avg. Conversion",
      agentPerformance: "Agent Performance",
      clickForDetails: "Click on an agent to view detailed report",
      rank: "Rank",
      agent: "Agent",
      totalClients: "Total Clients",
      newThisMonth: "New This Month",
      won: "Won",
      lost: "Lost",
      conversion: "Conversion",
      appointmentsCount: "Appointments",
      workload: "Workload",
      noAgents: "No agents found",
      noData: "No Data",
      noDataForPeriod: "No data available for this period",
      agentPerformanceReport: "Agent Performance Report",
      stagesDistribution: "Stages Distribution",
      monthlyPerformance: "Monthly Performance (Last 6 months)",
      recentClients: "Recent Clients",
      
      // Appointments
      appointmentsTitle: "Appointments",
      appointmentsDescription: "Manage property viewings and meetings",
      newAppointment: "New Appointment",
      totalAppointments: "Total Appointments",
      upcoming: "Upcoming",
      past: "Past",
      cancelled: "Cancelled",
      completed: "Completed",
      pending: "Pending",
      noAppointments: "No appointments",
      startAddingAppointment: "Start by adding a new appointment",
      editAppointment: "Edit Appointment",
      addNewAppointment: "Add New Appointment",
      title: "Title",
      titleExample: "E.g., Property viewing in Dubai Marina",
      client: "Client",
      selectClient: "Select Client",
      date: "Date",
      time: "Time",
      type: "Type",
      location: "Location",
      locationExample: "E.g., Dubai Marina, Tower X",
      optional: "Optional",
      propertyViewing: "Property Viewing",
      meeting: "Meeting",
      call: "Call",
      contractSigning: "Contract Signing",
      
      // Messages
      liveMessages: "Live Messages",
      trackMessages: "Track incoming messages and bot replies",
      activeChats: "Active Chats",
      noActiveChats: "No active chats",
      useTestButton: "Use the 'Test' button to send a test message",
      selectChat: "Select a chat to view",
      testBot: "Test Bot",
      testBotDescription: "Send a test message to see the bot's response",
      customerName: "Customer Name",
      message: "Message",
      messagePlaceholder: "Example: What's the price of product X?",
      sendTestMessage: "Send Test Message",
      tip: "Tip",
      tipAddProducts: "Make sure to add products for the bot to respond",
      test: "Test",
      send: "Send",
      newConversation: "New Conversation",
      startNewConversation: "Start a new conversation with a test customer",
      firstMessage: "First Message",
      startConversation: "Start Conversation",
      tipContinueChat: "Select a chat from the list to continue with an existing customer",
      typeCustomerMessage: "Type customer message...",
      simulateCustomerReply: "Simulate customer reply - Bot will respond automatically",
      continueConversation: "Continue Conversation",
      replyingTo: "Replying to:",
      sendReply: "Send Reply",
      messageSent: "Message sent",
      newChat: "New Chat",
      
      // Conversations
      conversationsHistory: "Conversations History",
      viewAllConversations: "View all past conversations",
      allConversations: "All Conversations",
      noConversations: "No conversations",
      messagesCount: "messages",
      close: "Close",
      closed: "Closed",
      selectConversation: "Select a conversation to view",
      
      // Properties
      propertiesManagement: "Properties Management",
      manageProducts: "Manage Products & Properties",
      addProperty: "Add Property",
      price: "Price",
      currency: "Currency",
      description: "Description",
      image: "Image",
      imageUrl: "Image URL",
      noProperties: "No properties",
      addFirstProperty: "Add your first property to start",
      editProduct: "Edit Product",
      addNewProduct: "Add New Product",
      productName: "Product Name",
      available: "Available",
      unavailable: "Unavailable",
      
      // Team page
      teamTitle: "Team Management",
      teamDescription: "Manage sales team and specializations",
      employeeDetails: "Employee Details",
      editEmployee: "Edit Employee",
      addNewEmployee: "Add New Employee",
      fullName: "Full Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      selectNationality: "Select Nationality",
      yearsOfExperience: "Years of Experience",
      specializations: "Specializations",
      areas: "Areas of Expertise",
      languages: "Languages",
      maxLeads: "Maximum Active Leads",
      bioDescription: "Employee Bio",
      bioPlaceholder: "Brief description of employee's experience and skills...",
      workloadBar: "Workload",
      inactive: "Inactive",
      enable: "Enable",
      
      // Register
      employeeRegistration: "Employee Registration",
      enterInvitationCode: "Enter Invitation Code",
      enterCodeDescription: "Enter the code sent by your administrator",
      whoAreYou: "Who are you?",
      employee: "Employee",
      workAtCompany: "I work at a real estate company",
      companyOwner: "Company Owner",
      ownCompany: "I own a real estate company",
      invitationCode: "Invitation Code",
      invitationCodeExample: "Example: AQR-ABCD12",
      verifyCode: "Verify Code",
      verifying: "Verifying...",
      haveAccount: "Already have an account?",
      createAccount: "Create Your Account",
      roleLabel: "Role",
      confirmPassword: "Confirm Password",
      passwordMinLength: "At least 6 characters",
      reenterPassword: "Re-enter password",
      next: "Next",
      previous: "Previous",
      completeProfile: "Complete Your Profile",
      tellUsAboutYou: "Tell us about your expertise",
      nationality: "Nationality",
      bio: "Bio",
      createAccountBtn: "Create Account",
      creatingAccount: "Creating Account...",
      accountInfo: "Account Info",
      profile: "Profile",
      passwordsNotMatch: "Passwords do not match",
      passwordTooShort: "Password must be at least 6 characters",
      registrationSuccess: "Registration successful! You can now log in",
      registrationFailed: "Registration failed",
      pleaseEnterCode: "Please enter invitation code",
      pleaseSelectType: "Please select account type",
      codeVerified: "Invitation code verified successfully!",
      invalidCode: "Invalid invitation code",
      
      loading: "Loading...",
      realtimeCRM: "Real Estate CRM",
      
      // Nationalities
      emirati: "Emirati",
      saudi: "Saudi",
      iraqi: "Iraqi",
      egyptian: "Egyptian",
      jordanian: "Jordanian",
      indian: "Indian",
      pakistani: "Pakistani",
      russian: "Russian",
      british: "British",
      american: "American",
      chinese: "Chinese",
      
      // Languages
      arabic: "Arabic",
      english: "English",
      hindi: "Hindi",
      urdu: "Urdu",
      russianLang: "Russian",
      chineseLang: "Chinese",
      french: "French",
      german: "German",
      spanish: "Spanish",
      persian: "Persian",
      turkish: "Turkish",
      
      // Specializations
      apartments: "Apartments",
      villas: "Villas",
      commercial: "Commercial",
      offices: "Offices",
      lands: "Lands",
      
      // Areas (legacy - now using geoData.js)
      dubaiMarina: "Dubai Marina",
      palmJumeirah: "Palm Jumeirah",
      downtown: "Downtown",
      jbr: "JBR",
      businessBay: "Business Bay",
      jumeirah: "Jumeirah",
      alBarsha: "Al Barsha",
      emiratesHills: "Emirates Hills",
      
      // Months
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
      
      // Time periods
      today: "Today",
      thisWeek: "This Week",
      thisMonth: "This Month",
      thisQuarter: "This Quarter",
      allPeriods: "All Periods",
      week: "Week",
      month: "Month",
      quarter: "Quarter",
      year: "Year",
      
      // Reports
      performanceReports: "Performance Reports",
      salesPerformanceAnalysis: "Track and analyze sales team performance",
      monthlyReport: "Monthly Report",
      overview: "Overview",
      teamPerformance: "Team Performance",
      trends: "Trends",
      topSalesAgents: "Top Sales Agents Ranking",
      
      // Pipeline stages
      pipelineNew: "New",
      pipelineQualified: "Qualified",
      pipelineUnqualified: "Unqualified",
      pipelineNegotiation: "Negotiation",
      pipelineClosedWon: "Closed Won",
      pipelineClosedLost: "Closed Lost",
      
      // Unqualified reasons
      reason: "Reason",
      unqualifiedReason: "Unqualified Reason",
      insufficientBudget: "Insufficient Budget",
      notSerious: "Not Serious",
      outOfScope: "Out of Scope",
      incorrectInfo: "Incorrect Information",
      otherReason: "Other",
      specifyReason: "Specify reason...",
      
      // Document upload
      uploadDocument: "Upload Document",
      documentRequired: "Passport or ID upload required to proceed to this stage",
      uploadPassportOrId: "Upload Passport or ID",
      capturePhoto: "Capture Photo",
      chooseFromGallery: "Choose from Gallery",
      extractingData: "Extracting data...",
      documentUploaded: "Document Uploaded",
      ocrSuccess: "Data extracted successfully",
      ocrFailed: "Failed to extract data",
      
      // Official data from OCR
      officialData: "Official Data",
      officialName: "Official Name",
      documentNumber: "Document Number",
      nationality: "Nationality",
      dateOfBirth: "Date of Birth",
      documentExpiry: "Document Expiry",
      expiringDocuments: "Expiring Documents",
      daysUntilExpiry: "Days until expiry",
      
      // Stage change
      changeStage: "Change Stage",
      stageHistory: "Stage Change History",
      changedBy: "Changed by",
      changedAt: "Changed at",
      
      // Creator and Distributor
      addedBy: "Added by",
      addedVia: "Added via",
      distributedBy: "Distributed by",
      distributionType: "Distribution Type",
      manualDistribution: "Manual",
      smartDistributionType: "Smart Distribution",
      autoDistribution: "Auto",
      manual: "Manual",
      unknown: "Unknown",
      
      // Client Number & Duplicate Detection
      clientNumber: "Client Number",
      duplicateDetected: "Potential Duplicate Client",
      duplicateWarning: "A client with the same data exists",
      duplicatePhone: "Phone number matches",
      duplicateEmail: "Email matches",
      duplicateBoth: "Phone and email match",
      keepBoth: "Add as New Client",
      mergeLead: "Merge with Existing Client",
      viewExisting: "View Existing Client",
      cancelAdd: "Cancel",
      existingClient: "Existing Client",
      newClient: "New Client",
      mergeSuccess: "Clients merged successfully",
      selectPrimaryLead: "Select primary client (will be kept)",
      selectSecondaryLead: "Select client to merge (will be deleted)",
      
      // Search
      searchByNamePhoneClientNumber: "Search by name, phone, or client number (CAE-2600001)...",
      searchResults: "Search results for",
      noSearchResults: "No search results found",
      
      // Advanced Filters
      advancedFilters: "Advanced Filters",
      resetFilters: "Reset Filters",
      allSources: "All Sources",
      website: "Website",
      messagePermissions: "Message Permissions",
      viewLiveMessages: "Live Messages",
      viewConversationHistory: "Conversation History",
      allStatuses: "All Statuses",
      allAgents: "All Agents",
      allTime: "All Time",
      dateAdded: "Date Added",
      today: "Today",
      thisWeek: "This Week",
      thisMonth: "This Month",
      last3Months: "Last 3 Months",
      assignedTo: "Assigned To",
      duplicates: "Duplicates",
      
      // Role access descriptions
      adminFullAccess: "⚠️ Admin has full system access",
      branchManagerAccess: "Branch Manager can manage employees in their branch",
      salesAgentAccess: "Sales Agent can only see assigned leads",
    }
  }
};

// Get saved language or default to Arabic
const savedLanguage = localStorage.getItem('language') || 'ar';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
